import clsx from 'clsx';
import { variants, colors, alignments, italic, underlineStrikethrough, underline, strikethrough } from './text.css.js';

/**
 * U+200E LEFT-TO-RIGHT MARK. Suppresses bidi reordering of punctuation when we flip direction
 * for start-truncation.
 */
const LTR_MARK = '\u200E';
/**
 * U+200B ZERO-WIDTH SPACE. Keeps an inline element's height equal to one text line even when
 * it would otherwise be empty (used inside the middle-truncation right span).
 */
const ZERO_WIDTH_SPACE = '\u200B';
/** Compose the shared class list applied to every `Text.*` element. */
function baseClassName(base, ...extras) {
    return clsx(variants[base.variant], colors[base.color], base.align && alignments[base.align], base.italic && italic, decorationClass(base.underline, base.strikethrough), ...extras);
}
/** Resolve a `truncate` prop into a `{ mode, lineClamp }` object. */
function parseTruncate(truncate) {
    switch (truncate) {
        case true:
        case 'end':
            return { mode: 'end' };
        case 'start':
            return { mode: 'start' };
        default:
            if (typeof truncate === 'number')
                return { mode: 'line-clamp', lineClamp: truncate };
            return { mode: undefined };
    }
}
/**
 * Invoke `callback` once after pending font loads settle. Returns a cleanup function that
 * cancels the pending invocation if disposal happens before fonts resolve.
 *
 * Web fonts can swap in after initial paint with different glyph metrics, which silently
 * shifts layout-dependent measurements like `scrollWidth` and rendered line count without
 * resizing the observed element. Resize/mutation observers don't fire in that case, so
 * callers that depend on those measurements need an explicit re-check hook.
 *
 * `document.fonts` is absent in jsdom-based unit tests, so the access is guarded.
 */
function onFontsReady(callback) {
    let cancelled = false;
    void document.fonts?.ready.then(() => {
        if (!cancelled)
            callback();
    });
    return () => {
        cancelled = true;
    };
}
function decorationClass(underline$1, strikethrough$1) {
    if (underline$1 && strikethrough$1)
        return underlineStrikethrough;
    if (underline$1)
        return underline;
    if (strikethrough$1)
        return strikethrough;
    return undefined;
}

export { LTR_MARK, ZERO_WIDTH_SPACE, baseClassName, onFontsReady, parseTruncate };
//# sourceMappingURL=text.utils.js.map
